<template>
	<div>
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<!-- <el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1480]')" width="120"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_Requisition_Type" :label="$t('getapi[3628]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[4910]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Row_Number" :label="$t('getapi[1425]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_Code" :label="$t('getapi[1513]')" width="120"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_Name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Part_Version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Specification" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Check_Std_Code" :label="$t('getapi[186]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Material_Std_Code" :label="$t('getapi[189]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Plan_Qty" :label="$t('getapi[1504]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Pur_MeasurementUnit" :label="$t('getapi[3100]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Expect_Ship_Date" :label="$t('getapi[1505]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Inventory_Qty" :label="$t('getapi[1506]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1507]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="already_pur_qty" :label="$t('getapi[1508]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Line_status" :label="$t('getapi[2954]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[163]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Create_Time" :label="$t('getapi[1478]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[4059]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[4279]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mrp_qty" :label="$t('getapi[1510]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mrp_time" :label="$t('getapi[1511]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Consumption_Date" :label="$t('getapi[1512]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="products" :label="$t('getapi[145]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Key_Flag" :label="$t('getapi[146]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="mrp_flag" :label="$t('getapi[6019]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="Purchase_Leadtime" :label="$t('getapi[1520]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip fixed="right" :label="$t('basic.edit')" width="120">
				<template slot-scope="scope">
					<el-button @click.native.prevent="lct(scope)" type="text" size="mini">采购业务图</el-button>
				</template>
			</el-table-column>
		</el-table> -->
		<!-- <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px"> -->
				<div class="btnnowrap">
                    <el-button type="primary" v-loading="loading_btn" size="mini"  @click="UpdateBOMShipMentLevelPart()" >{{ $t('getapi[13278]') }}</el-button>
                </div>
				<wTable id="xpane-0" 
						:data="dataSet" 
						:loading="loading"
						queryData="PurRequisitionLineViewInfo"
						:filter_language="['Line_Status','Key_Flag','mrp_flag']"
						:filter_thousandth="['Plan_Qty','Inventory_qty','already_Pur_Qty','Purchase_Leadtime']"
						:filter_date="['Expect_Ship_Date']"
						:header="tableHeader" 
						:option="tableOption" 
						@lct="lct" 
						ref="singleTable"></wTable>
			<!-- </li>
		</ul> -->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="PurRequisitionLineViewInfo" ref="ser" @getser="serclick"></serce>
		<!-- 改变表格顺序 -->
		<ctable :isVisible="false" :title="$t('getapi[98]')" queryData="PurRequisitionLineViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'purschemedetailview',
    computed: {
        tableOption() {
            return {
                border: true,
                // height: this.$windowSize.tableHeight3,
                // maxHeight: this.$windowSize.tableHeight3,
				height: this.$windowSize.tableHeight3,//Common.reduceTableHeight1_1,
				maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight1_1,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('purschemedetailview'), // 当前页数据量
			SelectIndexs: 0, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			loading_btn: false, // 主表加载状态
			tableHeader: [],
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
		that.colsort();
        that.$nextTick(function () {
            that.$processdata.initForm()
        })
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('PurRequisitionLineViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[98]"),this.$t("getapi[16]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 65, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 65, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('purschemedetailview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'PurRequisitionLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Pur/Requisition/OverViewDataList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
                    that.$nextTick(function () {
                        that.$processdata.initForm(0)
                    })
				}
			});
		},		
		// 更新物料的发货级物料信息
		UpdateBOMShipMentLevelPart() {
			let that = this	
			that.loading_btn=true;
			that.$http.urlpost('/Pur/Requisition/UpdateBOMShipMentLevelPartInfo', null, function (res) {
				if (res.Success == 1) {
					that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				that.loading_btn=false;
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
			that.$http.urlpost('/Pur/Requisition/OverViewExportToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
            /*let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "PurRequisitionLineViewInfo",
                fromname: that.$t('getapi[98]'),
                SelectIndex: that.SelectIndexs,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)*/
		},
		//销售关系
		lct(val) {
			let that = this;
            that.$store.commit('setSharedParams',val.row);
			let item = {
				label: '采购业务图',
				name: 'purbusiness',
				path: '/purbusiness/plan',
				url: '/purbusiness/plan',
				icon: 'video-play'
			};
			this.$router.push({ path: '/purbusiness/plan'});
			this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
